// "1 unit", "5 units": the word that follows a unit count.
export const getUnitsLabel = quantity => (Number(quantity) === 1 ? 'unit' : 'units');
